var map = {
	"./angpao.webp": 2279,
	"./bonus.webp": 2280,
	"./gpi-rebate-m.webp": 2281,
	"./gpi-rebate.webp": 2282,
	"./hublot-watch-2018.webp": 2283,
	"./hublot-watch-2022.webp": 2284,
	"./iphone-13-pro-max.webp": 2285,
	"./iphone-14-pro-max.webp": 2286,
	"./login-to-m.webp": 2287,
	"./login-to.webp": 2288,
	"./mb.webp": 2289,
	"./mg-rebate-m.webp": 2290,
	"./mg-rebate.webp": 2291,
	"./np.webp": 2292,
	"./pointer.webp": 2293,
	"./pp-rebate-m.webp": 2294,
	"./pp-rebate.webp": 2295,
	"./sadface.webp": 2296,
	"./wallet-m.webp": 2297,
	"./wallet.webp": 2298,
	"./wheel-b.webp": 2299,
	"./wheel-btn.webp": 2300,
	"./wheel-indon-b.webp": 2301,
	"./wheel-indon.webp": 2302,
	"./wheel.webp": 2303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 896;